import JobCategory from 'models/JobCategory';

import { Props as ButtonProps } from 'components/layout/Button';
import { ValuesTypes } from 'components/modules/public/pages/CompanySites/types';

import Component from './component';

export interface Props {
    list: JobCategory[];
    buttonProps: {
        search: ButtonProps;
        clear: ButtonProps;
        category: string;
    };
    onSearch: Function;
    onChange: Function;
    values: any;
    onClose: Function;
}

Component.defaultProps = {};

export default Component;